// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--l3FPM","post":"blog-module--post--2jlnK","postTitle":"blog-module--postTitle--17BwM"};